/* Copyright Verge Technologies 2018
 * @file technicalSupport.js
 * @author Brenton Watt <brenton@verge.co.za>
 */

// Modules
import React, { Component } from 'react';

// Components
import Header from '../../components/Header/header';
import Footer from '../../components/Footer/footer';
import RequestInformationModal from '../../components/RequestInformationModal/requestInformationModal';
import ThankYouModal from '../../components/ThankYouModal/thankyou.modal';



//import React from 'react';
import { Link } from 'react-router-dom';
import { Query } from 'react-apollo';
import { PulseLoader } from 'react-spinners';
// GraphQL
import { CONTENT_QUERY } from '../../graphql';


class TechnicalSupport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      infoModalOpen: false,
      thankYouModalOpen: false,
    };
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    return (
      <div>
        <Header crumbs={this.props.crumbs} />
        <RequestInformationModal
          isOpen={this.state.infoModalOpen}
          closeModal={() => this.setState({ ...this.state, infoModalOpen: false })}
          openThankYouModal={() => this.setState({ ...this.state, infoModalOpen: false, thankYouModalOpen: true })}
        />
        <ThankYouModal
          isOpen={this.state.thankYouModalOpen}
          closeModal={() => {
            this.setState({ ...this.state, thankYouModalOpen: false });
          }}
        />
        <div className="page-heading heading-support">Workflows</div>

      <Query query={CONTENT_QUERY} fetchPolicy="cache-and-network" variables={{ slug: "applications" }}>
        {({ loading, error, data }) => {
          if (loading) {
            return (


        <div className="content-list-container icon-list">
          <ul>
            <li className="services-card" style={{ height: 250 }}>
              <div className="icon-block">
                <div className="icon" style={{ margin: 0 }}>
                  <svg
                    viewBox="0 0 816 1056"
                    width="120px"
                    height="120px"
                  >
                    <defs id="defs6">
                      <clipPath
                        id="clipPath18"
                        clipPathUnits="userSpaceOnUse"
                      >
                        <path
                          id="path16"
                          d="M 0,792 H 612 V 0 H 0 Z" />
                      </clipPath>
                      <clipPath
                        id="clipPath30"
                        clipPathUnits="userSpaceOnUse"
                      >
                        <path
                          id="path28"
                          d="M 200,211.142 H 410.96 V 581.001 H 200 Z" />
                      </clipPath>
                    </defs>
                    <g transform="matrix(1.3333333,0,0,-1.3333333,0,1056)" id="g10">
                      <g id="g12">
                        <g clipPath="url(#clipPath18)" id="g14">
                          <g
                            transform="translate(285.4531,304.5596)"
                            id="g20"
                          >
                            <path
                              id="path22"
                              style={{ fill: '#004DA9', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none' }}
                              d="M 0,0 8.344,8.345 16.688,0 c 4.597,-4.597 4.597,-12.086 0,-16.683 C 12.086,-21.284 4.602,-21.284 0,-16.683 -4.601,-12.086 -4.601,-4.597 0,0 m 28,-28 c 10.84,10.841 10.84,28.478 0,39.317 l -14,14 c -3.125,3.125 -8.191,3.125 -11.316,0 l -14,-14 c -10.836,-10.839 -10.836,-28.476 0,-39.317 5.422,-5.418 12.539,-8.129 19.66,-8.129 7.117,0 14.238,2.711 19.656,8.129" />
                          </g>
                        </g>
                      </g>
                      <g id="g24">
                        <g clipPath="url(#clipPath30)" id="g26">
                          <g transform="translate(330.5352,409.6851)" id="g32">
                            <path
                              id="path34"
                              style={{ fill: '#004DA9', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none' }}
                              d="m 0,0 c -3.676,-16.898 -18.754,-29.593 -36.738,-29.593 -17.988,0 -33.063,12.695 -36.742,29.593 z m -90.336,8 c 0,-29.55 24.043,-53.593 53.598,-53.593 29.551,0 53.597,24.043 53.597,53.593 0,4.422 -3.583,8 -8,8 h -91.195 c -4.418,0 -8,-3.578 -8,-8"
                            />
                          </g>
                          <path
                            id="path36"
                            style={{ fill: '#004DA9', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none' }}
                            d="m 260.398,248.357 h 66.797 v -21.195 h -66.797 z m 51.454,228.235 c 12.339,-3.778 23.429,-11.571 31.226,-21.95 8.055,-10.722 12.313,-23.5 12.313,-36.957 0,-33.964 -27.629,-61.593 -61.594,-61.593 -33.965,0 -61.598,27.629 -61.598,61.593 0,13.457 4.258,26.235 12.313,36.957 7.797,10.379 18.886,18.172 31.226,21.95 3.364,1.031 5.657,4.136 5.657,7.652 v 52.102 h 24.8 v -52.102 c 0,-3.516 2.297,-6.621 5.657,-7.652 m -30.454,80.152 h 24.797 v -4.402 h -24.797 z m 120.993,24.398 c -4.418,0 -8,-3.582 -8,-8 v -20.796 h -72.196 v 12.398 c 0,4.418 -3.582,8 -8,8 h -40.8 c -4.418,0 -8,-3.582 -8,-8 v -12.402 h -9.399 c -4.418,0 -8,-3.579 -8,-8 0,-4.418 3.582,-8 8,-8 h 9.399 v -46.43 c -13.262,-5.242 -25.067,-14.203 -33.676,-25.66 -10.153,-13.516 -15.52,-29.617 -15.52,-46.567 0,-42.785 34.809,-77.597 77.598,-77.597 42.785,0 77.594,34.812 77.594,77.597 0,16.95 -5.368,33.051 -15.52,46.567 -8.609,11.457 -20.414,20.418 -33.676,25.66 v 46.434 h 72.196 V 227.162 h -51.196 v 29.195 c 0,4.418 -3.582,8 -8,8 h -82.797 c -4.418,0 -8,-3.582 -8,-8 V 227.162 H 208 c -4.418,0 -8,-3.582 -8,-8 0,-4.422 3.582,-8 8,-8 h 194.391 c 4.418,0 8,3.578 8,8 v 353.98 c 0,4.418 -3.582,8 -8,8"
                          />
                        </g>
                      </g>
                    </g>
                  </svg>
                </div>
                <h5>Method optimisation</h5>
              </div>
              <div className="content-block">
                <h2>Method optimisation</h2>
                <p>
                  Laboratory methods, assays and workflows
                </p>
              </div>
              <div className="control">
                <a
                  onClick={() => {
                    this.setState({ infoModalOpen: true });
                  }}
                  className="button button-green"
                >
                  Request info
                </a>
              </div>
            </li>
            <li className="services-card" style={{ height: 250 }}>
              <div className="icon-block">
                <div className="icon">
                  <svg
                    width="56px"
                    height="59px"
                    viewBox="0 0 56 59"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g
                      stroke="none"
                      strokeWidth="1"
                      fill="none"
                      fillRule="evenodd"
                      strokeLinecap="round"
                    >
                      <g transform="translate(1.000000, 2.000000)" stroke="#004DA9" strokeWidth="3">
                        <polyline points="41.23 21.02 48.267 13.983 38.813 4.529 31.776 11.566" />
                        <path d="M52.745,18.461 L34.335,0.122" />
                        <polygon
                          strokeLinejoin="round"
                          points="10.168 39.927 0.501 49.665 0.785 54.996 13.011 42.841"
                        />
                        <path d="M6.329,31.539 L25.236,12.561 L40.236,27.561 L21.329,46.466 L15.145,43.766 C12.3561744,42.5535576 10.141528,40.3134844 8.961,37.511 L6.329,31.539 Z" />
                        <path d="M19.195,6.519 L46.276,33.672" />
                        <polyline points="35.615 22.939 23.531 35.023 19.124 39.43" />
                        <path d="M17.56,28.412 L23.886,34.667" />
                        <path d="M23.46,22.512 L29.715,28.838" />
                      </g>
                    </g>
                  </svg>
                </div>
                <h5>Method development</h5>
              </div>
              <div className="content-block">
                <h2>Method development</h2>
                <p>
                  HPLC method development
                </p>
              </div>
              <div className="control">
                <a
                  onClick={() => {
                    this.setState({ infoModalOpen: true });
                  }}
                  className="button button-green"
                >
                  Request info
                </a>
              </div>
            </li>
            <li className="services-card" style={{ height: 250 }}>
              <div className="icon-block">
                <div className="icon">
                  <svg
                    width="66px"
                    height="59px"
                    viewBox="0 0 66 59"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                      <g transform="translate(1.000000, 1.000000)" stroke="#004DA9" strokeWidth="3">
                        <rect x="32.318" y="45.28" width="30.209" height="10.307" />
                        <path d="M40.99,31.5 L40.99,34.5" />
                        <path d="M55.419,34.5 L55.419,31.5" />
                        <path d="M33.527,16.991 L39.853,26.445" />
                        <path d="M50.799,20.403 L44.046,10.167" />
                        <circle cx="48.24" cy="28.221" r="8.387" />
                        <circle cx="35.659" cy="8.887" r="8.387" />
                        <path d="M34.166,17.062 L18.671,29.283 C17.4189965,30.2781268 15.8215137,30.7322261 14.2332641,30.5444675 C12.6450145,30.356709 11.197452,29.5426327 10.212,28.283 L9.359,27.146 C8.36387319,25.8939965 7.90977392,24.2965137 8.09753248,22.7082641 C8.28529104,21.1200145 9.09936729,19.672452 10.359,18.687 L29.048,3.983" />
                        <path d="M9.359,27.155 L1.114,34.121" strokeLinecap="round" />
                      </g>
                    </g>
                  </svg>
                </div>
                <h5>Assay design and automation</h5>
              </div>
              <div className="content-block">
                <h2>Assay design and automation</h2>
                <p>
                  High throughput workflow design
                </p>
              </div>
              <div className="control">
                <a
                  onClick={() => {
                    this.setState({ infoModalOpen: true });
                  }}
                  className="button button-green"
                >
                  Request info
                </a>
              </div>
            </li>
            <li className="services-card" style={{ height: 250 }}>
              <div className="icon-block">
                <div className="icon" style={{ margin: 0 }}>
                  <svg xmlns='http://www.w3.org/2000/svg' height='100' width='100' viewBox="0 0 650 567">
                    <rect id='backgroundrect' width='100%' height='100%' fill='none' />
                    <defs id='defs6'>
                      <clipPath id='clipPath18'>
                        <path id='path16' d='M 0,792 H 612 V 0 H 0 Z' />
                      </clipPath>
                    </defs>
                    <g className='currentLayer'>
                      <g id='svg_1' transform='translate(-56.5 -217.174)'>
                        <g id='svg_2' strokeWidth='0'>
                          <g clipPath='url(#clipPath18)' id='g14'>
                            <path id='path20' d='m642.6666506,713.3333419 h-15.9999996 v-258.6666602 h15.9999996 zm-437.33332240000004,-49.3333321 v-177.3333289 h37.3333324 v101.3333308 c0,23.5266660785 19.139999521500002,42.6666656 42.6666656,42.6666656 c23.5266660785,0 42.6666656,-19.139999521500002 42.6666656,-42.6666656 v-101.3333308 h37.3333324 v101.3333308 c0,23.5266660785 19.139999521500002,42.6666656 42.6666656,42.6666656 c23.5266660785,0 42.6666656,-19.139999521500002 42.6666656,-42.6666656 v-101.3333308 h37.3333324 v101.3333308 c0,23.5266660785 19.139999521500002,42.6666656 42.6666656,42.6666656 c23.5266660785,0 42.6666656,-19.139999521500002 42.6666656,-42.6666656 v-101.3333308 h37.3333324 V664.0000098 zm-15.9999996,49.3333321 h-15.9999996 v-258.6666602 h15.9999996 zm69.33333160000001,-226.666661 h53.333332 v101.3333308 c0,14.702666299099999 -11.963999700900002,26.666666 -26.666666,26.666666 c-14.702666299099999,0 -26.666666,-11.963999700900002 -26.666666,-26.666666 zm0,-143.99999640000001 h53.333332 v127.9999968 h-53.333332 zm122.6666636,143.99999640000001 h53.333332 v101.3333308 c0,14.702666299099999 -11.963999700900002,26.666666 -26.666666,26.666666 c-14.702666299099999,0 -26.666666,-11.963999700900002 -26.666666,-26.666666 zm0,-143.99999640000001 h53.333332 v127.9999968 h-53.333332 zm122.6666636,143.99999640000001 h53.333332 v101.3333308 c0,14.702666299099999 -11.963999700900002,26.666666 -26.666666,26.666666 c-14.702666299099999,0 -26.666666,-11.963999700900002 -26.666666,-26.666666 zm0,-143.99999640000001 h53.333332 v127.9999968 h-53.333332 zm146.666663,95.9999976 h-31.9999992 c-4.4173332229,0 -7.9999998,3.5839999104 -7.9999998,7.9999998 v23.9999994 h-37.3333324 v-127.9999968 h2.6666666 c4.4159998896,0 7.9999998,-3.5839999104 7.9999998,-7.9999998 c0,-4.4159998896 -3.5839999104,-7.9999998 -7.9999998,-7.9999998 h-90.6666644 c-4.4173332229,0 -7.9999998,3.5839999104 -7.9999998,7.9999998 c0,4.4159998896 3.5826665771000004,7.9999998 7.9999998,7.9999998 h2.6666666 v127.9999968 h-37.3333324 v-127.9999968 h2.6666666 c4.4159998896,0 7.9999998,-3.5839999104 7.9999998,-7.9999998 c0,-4.4159998896 -3.5839999104,-7.9999998 -7.9999998,-7.9999998 h-90.6666644 c-4.4159998896,0 -7.9999998,3.5839999104 -7.9999998,7.9999998 c0,4.4159998896 3.5839999104,7.9999998 7.9999998,7.9999998 h2.6666666 v127.9999968 h-37.3333324 v-127.9999968 h2.6666666 c4.4159998896,0 7.9999998,-3.5839999104 7.9999998,-7.9999998 c0,-4.4159998896 -3.5839999104,-7.9999998 -7.9999998,-7.9999998 h-90.6666644 c-4.4159998896,0 -7.9999998,3.5839999104 -7.9999998,7.9999998 c0,4.4159998896 3.5839999104,7.9999998 7.9999998,7.9999998 h2.6666666 v127.9999968 h-37.3333324 v-23.9999994 c0,-4.4159998896 -3.5839999104,-7.9999998 -7.9999998,-7.9999998 h-31.9999992 c-4.4159998896,0 -7.9999998,3.5839999104 -7.9999998,7.9999998 V721.3333417 c0,4.4173332229 3.5839999104,7.9999998 7.9999998,7.9999998 h31.9999992 c4.4159998896,0 7.9999998,-3.5826665771000004 7.9999998,-7.9999998 v-41.3333323 h405.3333232 v41.3333323 c0,4.4173332229 3.5826665771000004,7.9999998 7.9999998,7.9999998 h31.9999992 c4.4159998896,0 7.9999998,-3.5826665771000004 7.9999998,-7.9999998 v-274.6666598 c0,-4.4159998896 -3.5839999104,-7.9999998 -7.9999998,-7.9999998'
                              fill='#004DA9' />
                          </g>
                        </g>
                      </g>
                      <g id='svg_3' transform='translate(-56.5 -217.174)'>
                        <g id='svg_4' strokeWidth='0'>
                          <g clipPath='url(#clipPath18)' id='g14'>
                            <path id='path20' d='m642.6666506,713.3333419 h-15.9999996 v-258.6666602 h15.9999996 zm-437.33332240000004,-49.3333321 v-177.3333289 h37.3333324 v101.3333308 c0,23.5266660785 19.139999521500002,42.6666656 42.6666656,42.6666656 c23.5266660785,0 42.6666656,-19.139999521500002 42.6666656,-42.6666656 v-101.3333308 h37.3333324 v101.3333308 c0,23.5266660785 19.139999521500002,42.6666656 42.6666656,42.6666656 c23.5266660785,0 42.6666656,-19.139999521500002 42.6666656,-42.6666656 v-101.3333308 h37.3333324 v101.3333308 c0,23.5266660785 19.139999521500002,42.6666656 42.6666656,42.6666656 c23.5266660785,0 42.6666656,-19.139999521500002 42.6666656,-42.6666656 v-101.3333308 h37.3333324 V664.0000098 zm-15.9999996,49.3333321 h-15.9999996 v-258.6666602 h15.9999996 zm69.33333160000001,-226.666661 h53.333332 v101.3333308 c0,14.702666299099999 -11.963999700900002,26.666666 -26.666666,26.666666 c-14.702666299099999,0 -26.666666,-11.963999700900002 -26.666666,-26.666666 zm0,-143.99999640000001 h53.333332 v127.9999968 h-53.333332 zm122.6666636,143.99999640000001 h53.333332 v101.3333308 c0,14.702666299099999 -11.963999700900002,26.666666 -26.666666,26.666666 c-14.702666299099999,0 -26.666666,-11.963999700900002 -26.666666,-26.666666 zm0,-143.99999640000001 h53.333332 v127.9999968 h-53.333332 zm122.6666636,143.99999640000001 h53.333332 v101.3333308 c0,14.702666299099999 -11.963999700900002,26.666666 -26.666666,26.666666 c-14.702666299099999,0 -26.666666,-11.963999700900002 -26.666666,-26.666666 zm0,-143.99999640000001 h53.333332 v127.9999968 h-53.333332 zm146.666663,95.9999976 h-31.9999992 c-4.4173332229,0 -7.9999998,3.5839999104 -7.9999998,7.9999998 v23.9999994 h-37.3333324 v-127.9999968 h2.6666666 c4.4159998896,0 7.9999998,-3.5839999104 7.9999998,-7.9999998 c0,-4.4159998896 -3.5839999104,-7.9999998 -7.9999998,-7.9999998 h-90.6666644 c-4.4173332229,0 -7.9999998,3.5839999104 -7.9999998,7.9999998 c0,4.4159998896 3.5826665771000004,7.9999998 7.9999998,7.9999998 h2.6666666 v127.9999968 h-37.3333324 v-127.9999968 h2.6666666 c4.4159998896,0 7.9999998,-3.5839999104 7.9999998,-7.9999998 c0,-4.4159998896 -3.5839999104,-7.9999998 -7.9999998,-7.9999998 h-90.6666644 c-4.4159998896,0 -7.9999998,3.5839999104 -7.9999998,7.9999998 c0,4.4159998896 3.5839999104,7.9999998 7.9999998,7.9999998 h2.6666666 v127.9999968 h-37.3333324 v-127.9999968 h2.6666666 c4.4159998896,0 7.9999998,-3.5839999104 7.9999998,-7.9999998 c0,-4.4159998896 -3.5839999104,-7.9999998 -7.9999998,-7.9999998 h-90.6666644 c-4.4159998896,0 -7.9999998,3.5839999104 -7.9999998,7.9999998 c0,4.4159998896 3.5839999104,7.9999998 7.9999998,7.9999998 h2.6666666 v127.9999968 h-37.3333324 v-23.9999994 c0,-4.4159998896 -3.5839999104,-7.9999998 -7.9999998,-7.9999998 h-31.9999992 c-4.4159998896,0 -7.9999998,3.5839999104 -7.9999998,7.9999998 V721.3333417 c0,4.4173332229 3.5839999104,7.9999998 7.9999998,7.9999998 h31.9999992 c4.4159998896,0 7.9999998,-3.5826665771000004 7.9999998,-7.9999998 v-41.3333323 h405.3333232 v41.3333323 c0,4.4173332229 3.5826665771000004,7.9999998 7.9999998,7.9999998 h31.9999992 c4.4159998896,0 7.9999998,-3.5826665771000004 7.9999998,-7.9999998 v-274.6666598 c0,-4.4159998896 -3.5839999104,-7.9999998 -7.9999998,-7.9999998'
                              fill='#004DA9' />
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>
                </div>
                <h5>Process analysis and optimisation</h5>
              </div>
              <div className="content-block">
                <h2>Process analysis and optimisation</h2>
                <p>
                  Assessment of biopharmaceutical and biotherapeutics processes
                </p>
              </div>
              <div className="control">
                <a
                  onClick={() => {
                    this.setState({ infoModalOpen: true });
                  }}
                  className="button button-green"
                >
                  Request info
                </a>
              </div>
            </li>
            <li className="services-card" style={{ height: 250 }}>
              <div className="icon-block">
                <div className="icon">
                  <svg xmlns='http://www.w3.org/2000/svg' height='59' width='67'>
                    <rect id='backgroundrect' width='100%' height='100%' fill='none' />
                    <defs id='defs6'>
                      <clipPath id='clipPath18'>
                        <path id='path16' d='M 0,792 H 612 V 0 H 0 Z' />
                      </clipPath>
                    </defs>
                    <g className='currentLayer'>
                      <g id='g10'>
                        <g id='g12' strokeWidth='0'>
                          <g id='g14'>
                            <g id='g20'>
                              <path id='path22' d='m47.01054677337646,59.15051654747015 c-0.8853311200000001,0 -1.59866267,-0.7186648700000002 -1.59866267,-1.59866267 c0,-11.642637559999999 -9.46930966,-21.103947239999997 -21.105280569999998,-21.103947239999997 c-11.6399709,0 -21.10928056,9.46130968 -21.10928056,21.103947239999997 c0,0.8799978000000006 -0.71333155,1.59866267 -1.59866267,1.59866267 c-0.8799978000000006,0 -1.59866267,-0.7186648700000002 -1.59866267,-1.59866267 c0,-13.40129983 10.90130608,-24.309272559999997 24.306605899999997,-24.309272559999997 C37.70790336337649,33.242581317470126 48.60920944337647,44.15055404747011 48.60920944337647,57.551853877470194 C48.60920944337647,58.43185167747015 47.89587789337645,59.15051654747015 47.01054677337646,59.15051654747015'
                                fill='#004DA9' />
                            </g>
                            <g id='g24'>
                              <path id='path26' d='m23.23993562713622,9.88529954154967 c-5.9639850899999995,0 -10.813306299999999,4.849321209999999 -10.813306299999999,10.81197297 c0,5.95865177 4.849321209999999,10.813306299999999 10.813306299999999,10.813306299999999 c5.96265176,0 10.81197297,-4.8546545299999995 10.81197297,-10.813306299999999 C34.05190859713622,14.734620751549642 29.20258738713619,9.88529954154967 23.23993562713622,9.88529954154967 m0,24.82260461 c-7.729314009999999,0 -14.01596496,-6.286650949999999 -14.01596496,-14.010631639999998 c0,-7.723980689999999 6.286650949999999,-14.014631629999998 14.01596496,-14.014631629999998 c7.723980689999999,0 14.009298309999998,6.28531762 14.009298309999998,14.014631629999998 c0,7.723980689999999 -6.28531762,14.010631639999998 -14.009298309999998,14.010631639999998'
                                fill='#004DA9' />
                            </g>
                            <g id='g28'>
                              <path id='path30' d='m46.1505635717773,3.1973279802704155 c-0.25999934999999996,0 -0.4839987900000001,0.24533272 -0.4839987900000001,0.5213320300000001 c0,3.8746569799999997 0.0053333200000000025,13.999965 0.010666640000000005,14.35329745 l-0.0053333200000000025,6.239984399999999 l1.9519951199999999,-2.3906606900000003 c0.30799923,-0.37466573000000014 0.7613314300000003,-0.5879985300000002 1.2399969,-0.5879985300000002 h13.698632420000001 c0.18133288000000006,0 0.93733099,-0.3653324200000001 0.93733099,-0.7506647900000002 v-17.066624 C63.49985353177732,3.4213274202704156 63.046521331777285,3.1973279802704155 62.5625225417773,3.1973279802704155 zm-2.08799478,27.207931979999998 c-0.17733289000000005,0 -0.3599991,-0.03066659000000002 -0.53733199,-0.09333310000000006 c-0.6346650800000002,-0.22933276000000005 -1.06266401,-0.8333312500000003 -1.06266401,-1.5106628899999999 l0.015999960000000008,-10.697306589999998 c-0.0053333200000000025,-0.4119989700000002 -0.010666640000000005,-2.51599371 -0.015999960000000008,-14.385297369999998 c0,-2.05199487 1.65732919,-3.71865737 3.6879907800000002,-3.71865737 h16.411958969999997 c2.09866142,0 4.1399896499999995,1.5106628899999999 4.1399896499999995,3.5159912099999997 v17.066624 C66.70251219177732,22.723945830270395 64.55718422177728,24.53060798027036 62.5625225417773,24.53060798027036 H49.62388822177729 l-4.322655859999999,5.286653449999999 c-0.3066659000000001,0.37999905 -0.7653314200000002,0.5879985300000002 -1.23866357,0.5879985300000002'
                                fill='#004DA9' />
                            </g>
                            <g id='g32'>
                              <path id='path34' d='m57.63584573089594,14.399936692428582 c-0.8866644500000006,0 -1.59866267,-0.7186648700000002 -1.59866267,-1.599996 v-3.20265866 c0,-0.8799978000000006 0.7119982200000002,-1.59866267 1.59866267,-1.59866267 c0.8799978000000006,0 1.59866267,0.7186648700000002 1.59866267,1.59866267 V12.799940692428606 C59.23450840089595,13.681271822428585 58.51584353089595,14.399936692428582 57.63584573089594,14.399936692428582'
                                fill='#004DA9' />
                            </g>
                            <g id='g36'>
                              <path id='path38' d='m51.234535236816384,14.399936692428582 c-0.8853311200000001,0 -1.59866267,-0.7186648700000002 -1.59866267,-1.599996 v-3.20265866 c0,-0.8799978000000006 0.71333155,-1.59866267 1.59866267,-1.59866267 c0.8853311200000001,0 1.59866267,0.7186648700000002 1.59866267,1.59866267 V12.799940692428606 C52.833197906816395,13.681271822428585 52.119866356816374,14.399936692428582 51.234535236816384,14.399936692428582'
                                fill='#004DA9' />
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>
                </div>
                <h5>General Enquiries</h5>
              </div>
              <div className="content-block">
                <h2>General Enquiries</h2>
                <p>
                  Contact us for any enquiries
                </p>
              </div>
              <div className="control">
                <a
                  onClick={() => {
                    this.setState({ infoModalOpen: true });
                  }}
                  className="button button-green"
                >
                  Request info
                </a>
              </div>
            </li>
          </ul>
        </div>



            );
          }
          if (error) {
            console.log(error);
            return <div>Error</div>;
          }
          var html = data.getContent.body;
          var buttons = html.match(/<a[\s\S]*?>([\s\S]*?)<\/a>/g);

          return (

            <div>
          {buttons.map((b,i)=>{
              var m = b.match(/<a[\s\S]*?>([\s\S]*?)<\/a>/);
              var txt = m[1];
              return (
                        <a 
                          onClick={() => {
                            this.setState({ infoModalOpen: true });
                          }}
                          className="button button-green"
                          style={{display:"none"}}
                          id={txt}
                          key={i}

                        >
                          {txt}
                        </a>
                          )
          })}
                    <div dangerouslySetInnerHTML={{__html: html}}
                      onClick={(ev,ui) => {
    console.log("clicked");
    var cls = ev.target.className;
    var tag = ev.target.tagName;
    var targetid = ev.target.innerHTML;
    if(tag=="A" && cls=="button button-green"){
      console.log("[id='" + targetid + "']");
        document.querySelector("[id='" + targetid + "']").click();
    }                     
                      }}
                   />            
         
            </div>
          );

        }}
      </Query>


        <Footer />
      </div>
    );
  }
}

export default TechnicalSupport;



// WEBPACK FOOTER //
// ./src/pages/technicalSupport/technicalSupport.page.js